import React from "react";
import DateToday from "./DateToday";

export default function TopTitleBanner(props) {
  return (
    <div className="main-top-title-banner-container">
      <div
        className="date-container"
        style={{ display: "flex", alignItems: "center" }}
      >
        <DateToday />
        <div
          style={{
            backgroundColor: "green",
            marginLeft: "40px",
            borderRadius: "10px",
            paddingLeft: "10px",
            paddingRight: "10px",
            color: "white",
            fontSize: "12px",
          }}
        >
          DEMO VERSION
        </div>
      </div>
      <div className="title-text-banner">{props.title}</div>
    </div>
  );
}
